module.exports = "/packs/images/sprites/navigation~6309964995e77a04d5bb2a4d1a96bd32.png";